// extracted by mini-css-extract-plugin
module.exports = {"Blackberry":"#333D47","overlay":"ModalOverlay_overlay__286NA"};